import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { NotificationProvider } from "./components/ui/NotificationToast";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import PromptHistory from './pages/prompt-history';
import PromptGenerator from './pages/prompt-generator';
import UserProfileSettings from './pages/user-profile-settings';
import AdminDashboard from './pages/admin-dashboard';
import UseCaseAIToolManagement from './pages/use-case-ai-tool-management';
import UsageAnalyticsDashboard from './pages/usage-analytics-dashboard';
import LoginPage from './pages/login-page';
import ForgotPassword from './pages/forgot-password';
import AdminLayout from './components/layouts/AdminLayout';
import PublicLayout from './components/layouts/PublicLayout';
import ResetPassword from './pages/reset-password';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <ErrorBoundary>
            <ScrollToTop />
            <RouterRoutes>
              {/* Public routes - No authentication required */}
              <Route path="/" element={<PublicLayout><PromptGenerator /></PublicLayout>} />
              <Route path="/prompt-generator" element={<PublicLayout><PromptGenerator /></PublicLayout>} />
              
              {/* Authentication routes */}
              <Route path="/login-page" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Protected Admin routes - Require authentication */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><AdminDashboard /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/dashboard" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><AdminDashboard /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/generator" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><PromptGenerator /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/use-case-management" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><UseCaseAIToolManagement /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/analytics" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><UsageAnalyticsDashboard /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/user-profile-settings" 
                element={
                  <ProtectedRoute>
                    <UserProfileSettings />
                  </ProtectedRoute>
                } 
              />
              
              {/* Legacy protected routes - kept for backward compatibility */}
              <Route 
                path="/prompt-history" 
                element={
                  <ProtectedRoute>
                    <PromptHistory />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin-dashboard" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><AdminDashboard /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/use-case-ai-tool-management" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><UseCaseAIToolManagement /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/usage-analytics-dashboard" 
                element={
                  <ProtectedRoute>
                    <AdminLayout><UsageAnalyticsDashboard /></AdminLayout>
                  </ProtectedRoute>
                } 
              />
              
              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </ErrorBoundary>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
